import { Outlet } from 'react-router-dom';

export const Q_CompatibilityLong = () => {
  return <Outlet />;
};
